export default "__VITE_ASSET__a5c160e1__"